import {
  AddressElement,
  PaymentElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import React, {useEffect, useState} from "react";
import {handleError} from "../common/utils";
import agent from "../api/agent";
import {Skeleton} from "antd";
import ButtonLoading from "./ButtonLoading";
import PaypalPayment from "./PaypalPayment";
import TagManager from 'react-gtm-module'

const StripePayment = ({shippingAddress, googleAddressKey, invoiceId, invoiceAmount, packageId, paypalClientId, mobile, isAbandon = false, actionsLocked = false}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [useSameBillingAddress, setUseSameBillingAddress] = useState(true)
  const [billingAddress, setBillingAddress] = useState({name: shippingAddress.name,
    address: {
      line1: shippingAddress.street1,
      line2: shippingAddress.street2,
      city: shippingAddress.city,
      state: shippingAddress.stateCode,
      postal_code: shippingAddress.postalCode,
      country: shippingAddress.countryCode,
    }})

  let redirectUrl = mobile ? `${window.location.origin}/mobile/success` : `${window.location.origin}/done/packageShipping`

  if (isAbandon) {
    redirectUrl = `${window.location.origin}/done/packageAbandon`
  }

  useEffect(() => {
    if (stripe && elements) {
      setTimeout(() => {
        setIsReady(true);
      }, 500)
    }
  }, [stripe, elements]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (actionsLocked) {
      return
    }

    try {
      setIsLoading(true)
      setMessage('')

      await agent.checkout.requireShippingQuote({ invoiceId })

      const paymentResp = await stripe.confirmPayment({
        elements,
        confirmParams : {
          return_url: redirectUrl + `?invoiceId=${invoiceId}&packageId=${packageId}&invoiceAmount=${invoiceAmount}`,
          shipping: {
            name: shippingAddress.name,
            address: {
              line1: shippingAddress.street1,
              line2: shippingAddress.street2,
              city: shippingAddress.city,
              state: shippingAddress.stateCode,
              postal_code: shippingAddress.postalCode,
              country: shippingAddress.countryCode,
            }
          },
          payment_method_data: {
            billing_details: billingAddress
          }
        }
      })

      if (paymentResp.error) {
        setMessage(paymentResp.error.message)
      }

    } catch (error) {
      handleError(error)
    } finally {
      setIsLoading(false)
    }
  }


  if (!isReady) {
    return <Skeleton active={true}/>
  }

  return (
    <div className="stripe-payment-element">
      <form onSubmit={handleSubmit}>
        <h4>Payment Information</h4>
        <div className="srl-credit-label" style={{fontWeight: 'bold'}}>Billing Address</div>
        <div className="pad-t-10 " onClick={()=>{if (!actionsLocked) setUseSameBillingAddress(!useSameBillingAddress)}}>
          <div><i className="material-icons">{useSameBillingAddress ? 'check_box' : 'check_box_outline_blank'}</i>Billing is same as shipping information</div>
        </div>
        {!useSameBillingAddress && <div className='pad-t-10'>
          <AddressElement
            onChange={(event) => {setBillingAddress(event.value)}}
            options={{
              mode: 'billing',
              autocomplete: {
                mode: 'google_maps_api',
                apiKey: googleAddressKey
              }
            }}
          />
        </div>}
        <div className="srl-credit-label pad-t-10 pad-b-10" style={{fontWeight: 'bold'}}>Payment</div>
        <PaymentElement
          options={{
            layout: {
              type: 'tabs',
              defaultCollapsed: false,
            },
            defaultValues: {
              billingDetails: billingAddress
            },
            fields: {
              billingDetails: 'auto'
            }
          }}
        />

        {isLoading ? <div className="btn btn-primary mt-2 "><ButtonLoading/></div>:
          <div className="btn btn-primary mt-2 ">
            <button type="submit" className="btn btn-primary" style={{fontSize: '20px'}} disabled={actionsLocked}>Checkout</button>
          </div>}
        {message && <div className="error-text">{message}</div>}
      </form>
      {paypalClientId && <PaypalPayment paypalClientId={paypalClientId} invoiceId={invoiceId} invoiceAmount={invoiceAmount} packageId={packageId} redirectUrl={redirectUrl} disabled={actionsLocked}/>}
    </div>
  )

}

export default StripePayment